import type { CategoryCard } from '@/types';

export const categoryCards: CategoryCard[] = [
  {
    key: 'jp',
    name: '日本动漫',
    desc: '新番与经典齐聚，感受日式动画的魅力',
    count: 14,
    icon: 'ri-tv-2-line',
    filter: { field: 'region', value: '日本' },
  },
  {
    key: 'cn',
    name: '国产动漫',
    desc: '国漫崛起，东方美学与热血故事',
    count: 6,
    icon: 'ri-magic-line',
    filter: { field: 'region', value: '国产' },
  },
  {
    key: 'hotblood',
    name: '热血动漫',
    desc: '燃到最后一秒，为热血与羁绊欢呼',
    count: 5,
    icon: 'ri-fire-line',
    filter: { field: 'type', value: '热血' },
  },
  {
    key: 'fantasy',
    name: '奇幻冒险',
    desc: '另一个世界的奇思妙想与未知旅途',
    count: 6,
    icon: 'ri-planet-line',
    filter: { field: 'type', value: '奇幻' },
  },
  {
    key: 'healing',
    name: '治愈日常',
    desc: '温柔岁月里，藏着生活的小确幸',
    count: 4,
    icon: 'ri-leaf-line',
    filter: { field: 'type', value: '治愈' },
  },
  {
    key: 'romance',
    name: '恋爱校园',
    desc: '青涩心动，写给青春的情书',
    count: 3,
    icon: 'ri-heart-3-line',
    filter: { field: 'type', value: '恋爱' },
  },
];

export const typeOptions = ['热血', '奇幻', '恋爱', '科幻', '玄幻', '冒险', '治愈', '机甲', '悬疑', '推理', '运动', '日常', '古风', '武侠'];
export const regionOptions = ['日本', '国产', '欧美'];
export const yearOptions = [2024, 2023, 2022];
export const ratingOptions = [
  { label: '9.0 分以上', value: 9 },
  { label: '8.5 分以上', value: 8.5 },
  { label: '8.0 分以上', value: 8 },
];